/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


class DetailsBtn extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => this.classList.contains('open') 
      ? this.parentElement.parentElement.parentElement.setAttribute('data-open-description', true)
      : this.parentElement.parentElement.removeAttribute('data-open-description'));
  }
}
customElements.define('details-btn', DetailsBtn);
class PaymentOptions extends HTMLElement {
  constructor() {
    super();

    const popup = document.querySelector('.ProductMeta__PaymentOptions-popup');
    const close = popup.querySelector('.close-popup');
    const overlay = popup.querySelector('.overlay');

    this.querySelector('button').addEventListener('click', () => {
      document.querySelector('html').classList.add('no-scroll');
      popup.removeAttribute('hidden');
    });

    close.addEventListener('click', () => {
      document.querySelector('html').classList.remove('no-scroll');
      popup.setAttribute('hidden', 'hidden');
    });

    overlay.addEventListener('click', () => {
      document.querySelector('html').classList.remove('no-scroll');
      popup.setAttribute('hidden', 'hidden');
    });
  }
}
customElements.define('payment-options', PaymentOptions);
